var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 282,
    viewBox: "0 0 446 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2305_19935)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.273438,
    width: 446,
    height: 281.452,
    rx: 19.4105,
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.568 174.628C250.976 176.378 289.778 155.756 317.837 177.425C347.377 200.236 357.324 242.809 351.625 279.694C346.508 312.808 317.296 334.522 290.461 354.587C268.382 371.096 243.081 379.679 215.568 381.425C185.596 383.328 154.308 383.074 130.521 364.74C103.859 344.191 88.2666 313.028 83.5757 279.694C78.0463 240.402 71.6201 191.502 102.664 166.79C133.348 142.366 176.398 172.692 215.568 174.628Z",
    fill: "#10FF53",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.108 -57.6582C271.507 -52.7802 299.767 -22.632 319.99 9.20343C336.08 34.5342 335.872 65.4519 331.134 95.0847C327.234 119.477 312.751 138.85 296.311 157.288C278.385 177.393 260.933 201.459 234.108 203.906C205.77 206.491 179.258 190.174 159.419 169.774C139.871 149.671 133.741 122.589 128.286 95.0847C120.749 57.0848 100.401 15.2837 122.463 -16.5606C145.941 -50.4478 193.229 -62.9902 234.108 -57.6582Z",
    fill: "#00D1FF",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2305_19935"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.273438,
    width: 446,
    height: 281.452,
    rx: 19.4105,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard8);
export default __webpack_public_path__ + "static/media/card8.d4158ba84937ceb1dcbe3d4cf1a8e78f.svg";
export { ForwardRef as ReactComponent };